export enum CdnAssetType {
  MERCHANT_LOGO = 'merchant-logo',
  GIFT_CARD = 'gift-card',
}
